/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Page_Schedule_LeadInputs */

const en_pricing_page_schedule_lead = /** @type {(inputs: Pricing_Page_Schedule_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bookings without messages.`)
};

const pl_pricing_page_schedule_lead = /** @type {(inputs: Pricing_Page_Schedule_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacje bez wiadomości.`)
};

/**
* | output |
* | --- |
* | "Bookings without messages." |
*
* @param {Pricing_Page_Schedule_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const pricing_page_schedule_lead = /** @type {((inputs?: Pricing_Page_Schedule_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Page_Schedule_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_pricing_page_schedule_lead(inputs)
	return en_pricing_page_schedule_lead(inputs)
});